import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listCompartments } from '../Api'

export default generateApiAction({
  baseType: Types.COMPARTMENTS.LIST,
  api: listCompartments,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/compartments/ListAction.js